var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "form",
    {
      attrs: { id: "login" },
      on: {
        submit: function($event) {
          $event.preventDefault()
        }
      }
    },
    [
      _vm.errored
        ? _c("section", { staticClass: "overlay" }, [_vm._m(0)])
        : _c(
            "section",
            [
              _vm.loading
                ? _c("div", { staticClass: "overlay" }, [
                    _c("p", { staticClass: "overlay-text loading-text" }, [
                      _vm._v("Loading...")
                    ]),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "loading-spacer" },
                      [
                        _c("vue-loading", {
                          attrs: {
                            type: "spiningDubbles",
                            color: "#FFF",
                            size: { width: "100px", height: "100px" }
                          }
                        })
                      ],
                      1
                    )
                  ])
                : _vm._e(),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "margin-bottom-12" },
                [
                  _c("label", { staticClass: "error-text" }, [
                    _vm._v(_vm._s(_vm.mailError))
                  ]),
                  _vm._v(" "),
                  _c("InputMail", {
                    on: { "handle-change-mail": _vm.changeMail }
                  })
                ],
                1
              ),
              _vm._v(" "),
              _c("label", { staticClass: "error-text" }, [
                _vm._v(_vm._s(_vm.passwordError))
              ]),
              _vm._v(" "),
              _c("InputPassword", {
                on: { "handle-change-password": _vm.changePassword }
              }),
              _vm._v(" "),
              _c("div", { staticClass: "login" }, [
                _c("img", {
                  staticClass: "login-img",
                  attrs: { src: require("@/assets/top/アセット 2@2x.png") },
                  on: { click: _vm.clickLogin }
                })
              ])
            ],
            1
          )
    ]
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("p", { staticClass: "overlay-text" }, [
      _vm._v("申し訳ありませんが、"),
      _c("br"),
      _vm._v("現時点ではこの情報を取得できません。"),
      _c("br"),
      _vm._v("しばらくしてからもう一度お試しください")
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-22c73f36", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-22c73f36","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/organisms/LoginForm.vue
// module id = null
// module chunks = 